import React from 'react';

/**
 * Error Boundary for ReauthOverlay
 * 
 * Prevents the overlay from crashing the entire app if something goes wrong.
 * In production, silently catches errors and logs them.
 * The app continues to work normally even if session recovery UI fails.
 */
class ReauthOverlayErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('[ReauthOverlay Error]:', error, errorInfo);
    }
    
    // In production, you could send this to an error reporting service
    // Example: logErrorToService(error, errorInfo);
    
    // Reset error state after 5 seconds to retry
    setTimeout(() => {
      this.setState({ hasError: false });
    }, 5000);
  }

  render() {
    if (this.state.hasError) {
      // Return null to hide the overlay if it errors
      // This ensures the app continues to work even if overlay fails
      return null;
    }

    return this.props.children;
  }
}

export default ReauthOverlayErrorBoundary;